


let Footer = () => {
    return (
        <>
            <div className="footer-wrapper">
                <img width="160px" src="https://cdn.shopify.com/s/files/1/0420/7073/7058/files/blackoption_200x.png?v=1659016547" alt="" />
                <p className="mt-0 mb-0 copy">Copyright 2023</p>

                <ul className="social-handle">
                    <li><i class="bi bi-facebook"></i></li>
                    <li><i class="bi bi-twitter"></i></li>
                    <li><i class="bi bi-github"></i></li>
                    <li><i class="bi bi-instagram"></i></li>
                </ul>
            </div>
        </>
    )
}

export default Footer;